export default {
  methods: {
    removeUserNameOnComment (commentText, commentUsers) {
      if (commentUsers.length) {
        let newString = commentText
        commentUsers.forEach(({ name }) => {
          const reg = new RegExp(`(^|[^>])(${name})`, 'g')
          newString = newString.replace(reg, '')
        })
        return newString.replace(/@/g, '')
      }
      return commentText
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/removeUserNameOnComment.js